export function mask(str = "") {
    if (typeof str !== "string" || !str) {
        return '';
    } else if (str.length <= 3) {
        return '***';
    }
    return `**** **** ****${" " + str.substring(str.length - 4, str.length)}`;
}